// Core
import React from "react";

//Styles
import "./styles.scss";

// ErrorMessage component to display error messages
const ErrorMessage = ({ message }) => {
  if (!message) return null;

  return <p className="error-message">{message}</p>;
};

export default ErrorMessage;
